/**
 * BalanceTile — Saldo-flisen på Hjem (#154, ny i MAPPING.md for Hjem).
 *
 * Saldoen til den innloggede (`useBalance`), som lenke til lommeboken
 * (`/poeng`). Flisen er personlig, så OverviewRoute viser den bare med en
 * innlogget bruker. Før saldoen er hentet står en strek.
 */
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { formatPoints } from '../../../i18n/formatters';
import { useBalance } from '../../points/usePointsQueries';
import { MiniTile } from './MiniTile';

export function BalanceTile({ memberId }: { memberId: string }): ReactNode {
  const { t } = useTranslation();
  const { data: balance } = useBalance(memberId);
  return (
    <MiniTile
      to="/poeng"
      label={t('home.balance.label')}
      size="number"
      data-testid="home-balance-tile"
      valueTestId="home-balance"
    >
      {typeof balance === 'number'
        ? t('home.balance.value', { points: formatPoints(balance) })
        : t('home.balance.pending')}
    </MiniTile>
  );
}
